// REDUCER
import * as actionTypes from '../constants/actions';
import Auth from '../utils/authorization';

const defaultState = new Auth(konfig.user || {});

function userReceived(state, payload) {
	if (payload.hasOwnProperty('user') || payload.hasOwnProperty('message')) {
		return new Auth(payload.user);
	}

	return state;
}

function logout() {
	return new Auth({});
};

export default function userReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.USERS_LOGIN:
		case actionTypes.USERS_LOGIN_INIT:
		case actionTypes.USERS_ERROR:
		case actionTypes.USERS_LOGIN_FB:
		case actionTypes.USERS_LOGIN_TWITTER:
		case actionTypes.USERS_LOGIN_GOOGLE:
			return userReceived(state, action.payload);
		case actionTypes.USERS_LOGOUT:
			return logout();
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/users.js
 **/